/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for TodoStatusResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetTodoStatusByIdResponse, GetTodoStatusSelectResponse, GetTodoStatusesResponse } from "../models";

@Injectable({ providedIn: "root" })
export class TodoStatusResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getTodoStatusById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetTodoStatusByIdResponse, unknown> & { defaultValue: NoInfer<GetTodoStatusByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTodoStatusByIdResponse>;
    getTodoStatusById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetTodoStatusByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTodoStatusByIdResponse | undefined>;
    getTodoStatusById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetTodoStatusByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTodoStatusByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/TodoStatus/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getTodoStatusSelect(resourceOptions: HttpResourceOptions<GetTodoStatusSelectResponse, unknown> & { defaultValue: NoInfer<GetTodoStatusSelectResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTodoStatusSelectResponse>;
    getTodoStatusSelect(resourceOptions?: HttpResourceOptions<GetTodoStatusSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTodoStatusSelectResponse | undefined>;
    getTodoStatusSelect(resourceOptions?: HttpResourceOptions<GetTodoStatusSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTodoStatusSelectResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/TodoStatus/Select`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getTodoStatuses(resourceOptions: HttpResourceOptions<GetTodoStatusesResponse, unknown> & { defaultValue: NoInfer<GetTodoStatusesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTodoStatusesResponse>;
    getTodoStatuses(resourceOptions?: HttpResourceOptions<GetTodoStatusesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTodoStatusesResponse | undefined>;
    getTodoStatuses(resourceOptions?: HttpResourceOptions<GetTodoStatusesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTodoStatusesResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/TodoStatus`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
